export const minScale = 0.4; // The minimum scale of the document will be 50% there is a weird 10% added somewhere
export const defaultScale = 1.5;
